import { CONTENT_SECTION_IDS } from 'components/OfferPage/NavigableOfferContent/constants'
import type { OfferPageSnapshotContribution } from './offerPageSnapshotTypes'

// Maps the Navigable*OfferContent components' own local accordion-section ids
// to the stable section target already built by buildOfferPageSnapshot.ts for
// the currently rendered source variant. Not every UI section id has a
// snapshot-side target (e.g. a tour's 'itinerary' band isn't in the snapshot
// at all) -- those are intentionally left unmapped so activeControl is
// omitted rather than inventing a target that doesn't exist.
export const ACCORDION_SECTION_TARGET_IDS: Record<string, string> = {
  [CONTENT_SECTION_IDS.location]: 'location:root',
  [CONTENT_SECTION_IDS.highlights]: 'page:highlights',
  [CONTENT_SECTION_IDS.facilities]: 'facilities:root',
  [CONTENT_SECTION_IDS.facilitiesAll]: 'facilities:root',
  [CONTENT_SECTION_IDS.finePrint]: 'fine-print:root',
  [CONTENT_SECTION_IDS.finePrintSafety]: 'fine-print:root',
  [CONTENT_SECTION_IDS.customerReviews]: 'reviews:root',
}

/**
 * Shared by NavigableOfferContent/BedbankNavigableOfferContent/
 * PropertyNavigableOfferContent, whose own openFields/headerSelected state is
 * intentionally left as-is (pre-existing, duplicated per variant) -- only the
 * id-to-target mapping and contribution shape are centralised here, so the
 * three variants can't drift into spelling a target id differently.
 */
export function buildOfferPageAccordionContribution(
  key: string,
  headerSelected: string | undefined,
): OfferPageSnapshotContribution {
  const activeControl = headerSelected ? ACCORDION_SECTION_TARGET_IDS[headerSelected] : undefined

  return {
    key,
    sourcePath: `offer.accordion.${key}`,
    recentCommittedState: [],
    atoms: [],
    visibleState: { activeControl, suppressAutoFocus: false },
  }
}
